// extracted by mini-css-extract-plugin
module.exports = {"title":"FeatureSection_title__GaBV7","right":"FeatureSection_right__kEqRn","container":"FeatureSection_container__sp5AM","left":"FeatureSection_left__3nM_C"};